// extracted by mini-css-extract-plugin
module.exports = {"PaymentCardDetails":"PaymentCardDetails_5nWN1","PaymentLogo":"PaymentLogo_la0wV"};